import type { TFunction } from "i18next";
import type { EpostLetterResource } from "src/admin/modules/epost-letter/types.ts";

const documentLabel = (
  documentType: string | null | undefined,
  number: string | null | undefined,
  t: TFunction,
): string =>
  [
    t(`source.document.${documentType}`, {
      defaultValue: t("source.document.other"),
    }),
    number,
  ]
    .filter(Boolean)
    .join(" ");

/** «Quelle» письма словами: документ с номером, кампания или мастер. */
export const sourceLabel = (
  letter: EpostLetterResource,
  t: TFunction,
  // В карточке «Quelle» — ссылка на сам источник, документы внутри идут своей строкой.
  { withInside = true }: { withInside?: boolean } = {},
): string => {
  const source = letter.source;

  if (!source) {
    return t("source.manual");
  }

  // Мастер с Anschreiben: источник — «Brief», а человеку важен счёт внутри.
  const inside = withInside
    ? (letter.documents ?? []).filter(
        (document) => document.document_type !== "letter",
      )
    : [];

  if (
    source.type === "document" &&
    source.document_type === "letter" &&
    inside.length > 0
  ) {
    return `${inside
      .map((document) =>
        documentLabel(document.document_type, document.number, t),
      )
      .join(", ")} + ${t("source.coverLetter")}`;
  }

  if (source.type === "document") {
    return documentLabel(source.document_type, source.number, t);
  }

  return t(`source.${source.type}`, { defaultValue: t("source.other") });
};
